import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IFormValues } from "src/Pages/Company/OrganizationStructure/Forms/EditStructureForm/EditStructureForm.schema";
import { saveEditStructureForm } from "src/Pages/Company/OrganizationStructure/api";
import { dynamicNotification } from "src/utils/Notifications";

const useSaveEditStructureForm = (
  companyId: string,
  structureId: string,
  onSuccessCallback: () => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData: IFormValues) =>
      saveEditStructureForm(companyId, structureId, formData),
    onSuccess: () => {
      dynamicNotification("Pomyślnie zapisano dane", "success");
      onSuccessCallback();
      queryClient.invalidateQueries({
        queryKey: ["structure-data", { companyId, structureId }],
      });
    },
    onError: () => {
      dynamicNotification("Nie udało się zapisać danych", "error");
    },
  });
};

export default useSaveEditStructureForm;
